export interface Movie {
  id: string;
  title: string;
  year: number;
  region: string;
  genres: string[];
  version: string;
  rating: number;
  views: number;
  duration: string;
  director: string;
  actors: string[];
  subtitle: string;
  cover: string;
  description: string;
  tags: string[];
}

export const movies: Movie[] = [
  {
    id: "jky-001",
    title: "饥渴的岳：暗夜之城",
    year: 2024,
    region: "中国香港",
    genres: ["悬疑", "犯罪"],
    version: "中文字幕BD",
    rating: 8.4,
    views: 128400,
    duration: "118分钟",
    director: "陈屿舟",
    actors: ["梁烬", "苏婉清", "何仲川"],
    subtitle: "简体中文 / 繁体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=moody%20cinematic%20movie%20poster%20of%20a%20lone%20man%20walking%20through%20a%20rainy%20neon%20city%20at%20night%2C%20deep%20crimson%20and%20black%20tones%2C%20dramatic%20shadow%2C%20film%20noir%20atmosphere%2C%20vertical%20composition&width=600&height=900&seq=movie-poster-jky001&orientation=portrait",
    description: "岳山河重返阔别十年的港城，只为查明弟弟离奇身亡的真相。越接近真相，他越发现自己早已被这座城市吞没。",
    tags: ["系列首作", "港片", "雨夜"],
  },
  {
    id: "jky-002",
    title: "饥渴的岳2：血色黎明",
    year: 2025,
    region: "中国香港",
    genres: ["动作", "犯罪"],
    version: "中文字幕4K",
    rating: 8.1,
    views: 96700,
    duration: "126分钟",
    director: "陈屿舟",
    actors: ["梁烬", "林越", "苏婉清"],
    subtitle: "简体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20action%20film%20poster%20with%20a%20silhouette%20facing%20a%20blood%20red%20sunrise%20over%20a%20harbor%2C%20dark%20contrast%20lighting%2C%20deep%20red%20and%20charcoal%20palette%2C%20gritty%20texture%2C%20vertical%20layout&width=600&height=900&seq=movie-poster-jky002&orientation=portrait",
    description: "昔日对手成为唯一盟友。岳山河必须在黎明之前做出选择：是复仇，还是让真相活下去。",
    tags: ["系列续作", "枪战", "黎明"],
  },
  {
    id: "jky-003",
    title: "饥渴的岳3：孤岛回声",
    year: 2026,
    region: "中国大陆",
    genres: ["悬疑", "惊悚"],
    version: "中文字幕BD",
    rating: 7.9,
    views: 58400,
    duration: "112分钟",
    director: "沈砚",
    actors: ["何仲川", "顾也", "白薇"],
    subtitle: "简体中文 / 繁体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=atmospheric%20thriller%20poster%20of%20a%20foggy%20isolated%20island%20with%20a%20lonely%20lighthouse%2C%20muted%20deep%20red%20signal%20light%2C%20dark%20teal%20to%20black%20gradient%2C%20mysterious%20mood%2C%20vertical%20movie%20poster&width=600&height=900&seq=movie-poster-jky003&orientation=portrait",
    description: "一座与世隔绝的海岛，七个陌生人，一段不断重复的录音。真相比孤岛更让人窒息。",
    tags: ["系列新作", "孤岛", "心理"],
  },
  {
    id: "jky-004",
    title: "饥渴的岳：前传·锈色往事",
    year: 2022,
    region: "中国香港",
    genres: ["剧情", "犯罪"],
    version: "中文字幕合集",
    rating: 8.6,
    views: 154200,
    duration: "134分钟",
    director: "陈屿舟",
    actors: ["梁烬", "罗砚秋", "郑淮"],
    subtitle: "简体中文 / 繁体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=nostalgic%20crime%20drama%20poster%20of%20an%20old%20rusty%20industrial%20dock%20at%20dusk%2C%20deep%20burgundy%20smoke%2C%20warm%20amber%20highlights%2C%20weathered%20metal%20texture%2C%20dark%20cinematic%20vertical%20layout&width=600&height=900&seq=movie-poster-jky004&orientation=portrait",
    description: "在他成为传说之前，岳山河只是一个替人顶罪的码头工人。这是所有故事的起点。",
    tags: ["前传", "年代", "码头"],
  },
  {
    id: "jky-005",
    title: "饥渴的岳：午夜列车",
    year: 2023,
    region: "韩国",
    genres: ["悬疑", "惊悚"],
    version: "中文字幕BD",
    rating: 7.7,
    views: 74200,
    duration: "108分钟",
    director: "朴振宇",
    actors: ["李度宪", "何仲川", "崔敏书"],
    subtitle: "简体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=suspenseful%20movie%20poster%20of%20a%20night%20express%20train%20rushing%20through%20darkness%2C%20interior%20amber%20light%2C%20deep%20crimson%20accent%2C%20cold%20blue%20black%20mood%2C%20cinematic%20vertical%20poster&width=600&height=900&seq=movie-poster-jky005&orientation=portrait",
    description: "开往釜山的午夜列车没有终点。每停一站，车上就少一个人——而没有人记得他们何时上车。",
    tags: ["跨国合作", "列车", "密闭空间"],
  },
  {
    id: "jky-006",
    title: "饥渴的岳：双生之刃",
    year: 2024,
    region: "中国台湾",
    genres: ["动作", "剧情"],
    version: "中文字幕DV",
    rating: 7.5,
    views: 43100,
    duration: "104分钟",
    director: "黄立森",
    actors: ["顾也", "白薇", "梁烬"],
    subtitle: "繁体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=double%20exposure%20movie%20poster%20showing%20two%20mirrored%20figures%20back%20to%20back%2C%20deep%20red%20and%20graphite%20palette%2C%20sharp%20blade%20glint%2C%20high%20contrast%20dark%20cinematic%20vertical%20composition&width=600&height=900&seq=movie-poster-jky006&orientation=portrait",
    description: "一对孪生兄弟，一个站在光里，一个藏在暗处。当其中一人消失，另一个必须活成他的样子。",
    tags: ["双生", "兄弟", "身份"],
  },
  {
    id: "jky-007",
    title: "饥渴的岳：边境来客",
    year: 2021,
    region: "中国大陆",
    genres: ["犯罪", "剧情"],
    version: "中文字幕HD",
    rating: 7.3,
    views: 38900,
    duration: "121分钟",
    director: "沈砚",
    actors: ["郑淮", "罗砚秋", "何仲川"],
    subtitle: "简体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=bleak%20border%20town%20movie%20poster%20with%20a%20solitary%20car%20on%20an%20empty%20deserted%20road%2C%20deep%20crimson%20sky%2C%20dust%20and%20dark%20brown%20tones%2C%20gritty%20cinematic%20vertical%20layout&width=600&height=900&seq=movie-poster-jky007&orientation=portrait",
    description: "一个来路不明的旅人住进了边境小城的旅店，从此小镇的平静被彻底打破。",
    tags: ["边境", "小镇", "黑色电影"],
  },
  {
    id: "jky-008",
    title: "饥渴的岳：雾港迷踪",
    year: 2023,
    region: "中国香港",
    genres: ["悬疑", "犯罪"],
    version: "中文字幕BD",
    rating: 8.0,
    views: 86400,
    duration: "115分钟",
    director: "陈屿舟",
    actors: ["梁烬", "林越", "苏婉清"],
    subtitle: "简体中文 / 繁体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=foggy%20harbor%20at%20night%20movie%20poster%20with%20cargo%20ships%20and%20dim%20red%20dock%20lights%2C%20dense%20mist%2C%20dark%20charcoal%20and%20crimson%20palette%2C%20mysterious%20cinematic%20vertical%20layout&width=600&height=900&seq=movie-poster-jky008&orientation=portrait",
    description: "浓雾笼罩的港口连续出现无名集装箱。岳山河发现，里面装的全是与自己有关的记忆。",
    tags: ["港片", "港口", "记忆"],
  },
  {
    id: "jky-009",
    title: "饥渴的岳：无声证词",
    year: 2022,
    region: "日本",
    genres: ["悬疑", "剧情"],
    version: "中文字幕4K",
    rating: 8.2,
    views: 71300,
    duration: "129分钟",
    director: "佐藤健吾",
    actors: ["高桥悠真", "苏婉清", "何仲川"],
    subtitle: "简体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=quiet%20minimal%20japanese%20thriller%20poster%20of%20an%20empty%20courtroom%20with%20a%20single%20red%20evidence%20light%2C%20muted%20grey%20and%20burgundy%20tones%2C%20restrained%20elegant%20vertical%20composition&width=600&height=900&seq=movie-poster-jky009&orientation=portrait",
    description: "唯一的目击者是位失语者。他记得一切，却无法开口——而凶手知道他记得。",
    tags: ["法庭", "日式", "沉默"],
  },
  {
    id: "jky-010",
    title: "饥渴的岳：焚城时刻",
    year: 2025,
    region: "中国香港",
    genres: ["动作", "惊悚"],
    version: "中文字幕4K",
    rating: 7.8,
    views: 102600,
    duration: "131分钟",
    director: "陈屿舟",
    actors: ["梁烬", "顾也", "崔敏书"],
    subtitle: "简体中文 / 繁体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=explosive%20action%20poster%20of%20a%20burning%20city%20skyline%20at%20night%20with%20orange%20flames%20against%20black%20smoke%2C%20deep%20red%20embers%2C%20high%20contrast%20cinematic%20vertical%20layout&width=600&height=900&seq=movie-poster-jky010&orientation=portrait",
    description: "整座城市在四十八小时内陷入火海。岳山河只剩一个选择：冲进火里，还是看着一切烧尽。",
    tags: ["爆炸", "末日", "高燃"],
  },
  {
    id: "jky-011",
    title: "饥渴的岳：旧照片",
    year: 2020,
    region: "中国台湾",
    genres: ["剧情", "文艺"],
    version: "中文字幕DVD",
    rating: 7.6,
    views: 33200,
    duration: "99分钟",
    director: "黄立森",
    actors: ["白薇", "罗砚秋"],
    subtitle: "繁体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=artsy%20nostalgic%20movie%20poster%20featuring%20a%20faded%20old%20photograph%20held%20in%20hands%2C%20sepia%20and%20deep%20brick%20red%20tones%2C%20soft%20grain%2C%20emotional%20minimal%20vertical%20composition&width=600&height=900&seq=movie-poster-jky011&orientation=portrait",
    description: "一张泛黄的旧照片，牵出岳家三代人从未说起过的秘密。",
    tags: ["文艺", "家庭", "回忆"],
  },
  {
    id: "jky-012",
    title: "饥渴的岳：猎影者",
    year: 2024,
    region: "美国",
    genres: ["惊悚", "犯罪"],
    version: "中文字幕BD",
    rating: 7.4,
    views: 55100,
    duration: "117分钟",
    director: "Marcus Reed",
    actors: ["梁烬", "Elena Ward", "郑淮"],
    subtitle: "简体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=noir%20hunter%20thriller%20poster%20of%20a%20shadowy%20figure%20with%20a%20camera%20stalking%20through%20a%20dark%20alley%2C%20deep%20red%20backlight%2C%20smoky%20grain%2C%20gritty%20cinematic%20vertical%20layout&width=600&height=900&seq=movie-poster-jky012&orientation=portrait",
    description: "一名专拍犯罪现场的摄影师，意外拍到了一场尚未发生的谋杀。",
    tags: ["跨国", "偷拍", "都市"],
  },
  {
    id: "jky-013",
    title: "饥渴的岳：雪夜归人",
    year: 2021,
    region: "韩国",
    genres: ["剧情", "悬疑"],
    version: "中文字幕BD",
    rating: 8.3,
    views: 60700,
    duration: "124分钟",
    director: "朴振宇",
    actors: ["李度宪", "崔敏书", "何仲川"],
    subtitle: "简体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=snowy%20night%20drama%20poster%20with%20a%20solitary%20figure%20trudging%20through%20deep%20snow%20toward%20a%20warm%20dim%20red%20window%20light%2C%20cold%20grey%20and%20crimson%20palette%2C%20cinematic%20vertical%20poster&width=600&height=900&seq=movie-poster-jky013&orientation=portrait",
    description: "消失十年的丈夫在暴雪之夜敲响了家门，而妻子记得，他的葬礼就在三年前。",
    tags: ["雪夜", "悬疑", "重逢"],
  },
  {
    id: "jky-014",
    title: "饥渴的岳：名单",
    year: 2025,
    region: "中国大陆",
    genres: ["犯罪", "动作"],
    version: "中文字幕4K",
    rating: 8.0,
    views: 118900,
    duration: "128分钟",
    director: "沈砚",
    actors: ["梁烬", "顾也", "林越"],
    subtitle: "简体中文 / 繁体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=tense%20crime%20poster%20of%20a%20burnt%20paper%20list%20held%20over%20a%20flame%2C%20deep%20red%20glow%20on%20dark%20background%2C%20sharp%20dramatic%20shadow%2C%20vertical%20cinematic%20layout&width=600&height=900&seq=movie-poster-jky014&orientation=portrait",
    description: "一份写着十三个名字的名单，每划掉一个，就有一条人命消失。",
    tags: ["复仇", "名单", "高能"],
  },
  {
    id: "jky-015",
    title: "饥渴的岳：回声之地",
    year: 2022,
    region: "法国",
    genres: ["文艺", "剧情"],
    version: "中文字幕合集",
    rating: 7.9,
    views: 28700,
    duration: "106分钟",
    director: "Léa Aubert",
    actors: ["罗砚秋", "白薇"],
    subtitle: "简体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=art%20house%20film%20poster%20of%20an%20empty%20stone%20courtyard%20with%20long%20echoing%20shadows%2C%20muted%20terracotta%20and%20deep%20burgundy%20palette%2C%20poetic%20european%20cinematic%20vertical%20layout&width=600&height=900&seq=movie-poster-jky015&orientation=portrait",
    description: "在一座即将拆除的老剧院里，两个陌生人用声音交换了彼此错过的半生。",
    tags: ["欧洲", "文艺", "剧院"],
  },
  {
    id: "jky-016",
    title: "饥渴的岳：逆流",
    year: 2023,
    region: "中国香港",
    genres: ["剧情", "运动"],
    version: "中文字幕HD",
    rating: 7.2,
    views: 31900,
    duration: "110分钟",
    director: "黄立森",
    actors: ["郑淮", "顾也"],
    subtitle: "繁体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=inspirational%20sports%20drama%20poster%20of%20a%20swimmer%20cutting%20through%20dark%20water%2C%20deep%20red%20lane%20markings%2C%20moody%20low%20light%2C%20dynamic%20cinematic%20vertical%20composition&width=600&height=900&seq=movie-poster-jky016&orientation=portrait",
    description: "被禁赛五年的泳将重返赛道，他要战胜的不是对手，而是自己早已放弃的那部分。",
    tags: ["励志", "竞技", "回归"],
  },
  {
    id: "jky-017",
    title: "饥渴的岳：夜巡人",
    year: 2024,
    region: "中国台湾",
    genres: ["惊悚", "犯罪"],
    version: "中文字幕BD",
    rating: 7.5,
    views: 47500,
    duration: "113分钟",
    director: "黄立森",
    actors: ["何仲川", "白薇", "林越"],
    subtitle: "简体中文 / 繁体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=late%20night%20security%20patrol%20poster%20of%20a%20security%20guard%20with%20a%20flashlight%20in%20a%20dark%20parking%20garage%2C%20deep%20crimson%20emergency%20light%2C%20tense%20cinematic%20vertical%20layout&width=600&height=900&seq=movie-poster-jky017&orientation=portrait",
    description: "夜班保安发现，每晚监控里都会多出一个不该存在的影子。",
    tags: ["夜班", "监控", "悬疑"],
  },
  {
    id: "jky-018",
    title: "饥渴的岳：失语者",
    year: 2020,
    region: "日本",
    genres: ["剧情", "悬疑"],
    version: "中文字幕BD",
    rating: 8.1,
    views: 39200,
    duration: "122分钟",
    director: "佐藤健吾",
    actors: ["高桥悠真", "罗砚秋"],
    subtitle: "简体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=quiet%20melancholic%20japanese%20poster%20of%20a%20person%20writing%20in%20a%20notebook%20by%20a%20single%20warm%20lamp%2C%20deep%20brown%20and%20crimson%20shadow%2C%20gentle%20grain%2C%20cinematic%20vertical%20composition&width=600&height=900&seq=movie-poster-jky018&orientation=portrait",
    description: "一个无法说话的男人，用一整本笔记本，讲述了他与岳家不得不说的往事。",
    tags: ["日式", "书信", "slow burn"],
  },
  {
    id: "jky-019",
    title: "饥渴的岳：红隼行动",
    year: 2025,
    region: "中国大陆",
    genres: ["动作", "战争"],
    version: "中文字幕4K",
    rating: 7.7,
    views: 92500,
    duration: "137分钟",
    director: "沈砚",
    actors: ["顾也", "林越", "郑淮"],
    subtitle: "简体中文 / 繁体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=military%20action%20poster%20of%20a%20special%20forces%20unit%20silhouetted%20against%20a%20deep%20red%20smoke%20sky%2C%20helicopter%20blur%2C%20dark%20gritty%20palette%2C%20cinematic%20vertical%20layout&width=600&height=900&seq=movie-poster-jky019&orientation=portrait",
    description: "代号“红隼”的营救行动，从一开始就是一场没有人打算让任何人活着回来的骗局。",
    tags: ["军事", "营救", "硬核"],
  },
  {
    id: "jky-020",
    title: "饥渴的岳：同谋",
    year: 2023,
    region: "英国",
    genres: ["犯罪", "剧情"],
    version: "中文字幕BD",
    rating: 8.2,
    views: 52600,
    duration: "120分钟",
    director: "Oliver Hayes",
    actors: ["梁烬", "Charlotte Bell", "何仲川"],
    subtitle: "简体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=cold%20british%20crime%20poster%20of%20two%20men%20shaking%20hands%20in%20shadow%2C%20deep%20maroon%20and%20graphite%20tones%2C%20rain%20on%20glass%2C%20restrained%20cinematic%20vertical%20layout&width=600&height=900&seq=movie-poster-jky020&orientation=portrait",
    description: "他以为自己是受害者，直到发现自己才是这场阴谋真正的同谋。",
    tags: ["英伦", "罪案", "反转"],
  },
  {
    id: "jky-021",
    title: "饥渴的岳：黑白之间",
    year: 2021,
    region: "中国香港",
    genres: ["犯罪", "剧情"],
    version: "中文字幕合集",
    rating: 8.5,
    views: 132700,
    duration: "139分钟",
    director: "陈屿舟",
    actors: ["梁烬", "罗砚秋", "林越"],
    subtitle: "简体中文 / 繁体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=high%20contrast%20black%20and%20white%20crime%20poster%20split%20by%20a%20single%20red%20line%2C%20minimal%20geometric%20shapes%2C%20deep%20burgundy%20accent%2C%20cinematic%20vertical%20layout&width=600&height=900&seq=movie-poster-jky021&orientation=portrait",
    description: "卧底十年，他终于分不清自己是警察还是罪犯——包括他自己。",
    tags: ["卧底", "经典", "双面"],
  },
  {
    id: "jky-022",
    title: "饥渴的岳：雨夜信使",
    year: 2022,
    region: "韩国",
    genres: ["悬疑", "爱情"],
    version: "中文字幕HD",
    rating: 7.4,
    views: 35800,
    duration: "105分钟",
    director: "朴振宇",
    actors: ["崔敏书", "高桥悠真"],
    subtitle: "简体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=romantic%20rainy%20night%20poster%20of%20a%20messenger%20holding%20a%20letter%20under%20an%20umbrella%2C%20warm%20amber%20and%20deep%20rose%20tones%2C%20soft%20bokeh%20city%20lights%2C%20vertical%20cinematic%20composition&width=600&height=900&seq=movie-poster-jky022&orientation=portrait",
    description: "每个雨夜，都有同一个信使送来一封没有署名的信。她等了七年，只为见写信人一面。",
    tags: ["雨夜", "爱情", "信"],
  },
  {
    id: "jky-023",
    title: "饥渴的岳：第九号证人",
    year: 2024,
    region: "中国大陆",
    genres: ["悬疑", "犯罪"],
    version: "中文字幕BD",
    rating: 7.8,
    views: 68100,
    duration: "119分钟",
    director: "沈砚",
    actors: ["何仲川", "白薇", "郑淮"],
    subtitle: "简体中文 / 繁体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=interrogation%20room%20crime%20poster%20with%20an%20empty%20chair%20lit%20by%20a%20single%20deep%20red%20hanging%20lamp%2C%20dark%20grey%20walls%2C%20claustrophobic%20cinematic%20vertical%20layout&width=600&height=900&seq=movie-poster-jky023&orientation=portrait",
    description: "八名证人指認了同一个凶手，可第九号证人说的是完全相反的故事。",
    tags: ["庭审", "反转", "群像"],
  },
  {
    id: "jky-024",
    title: "饥渴的岳：锈带往事",
    year: 2020,
    region: "中国大陆",
    genres: ["剧情", "家庭"],
    version: "中文字幕DV",
    rating: 8.0,
    views: 29600,
    duration: "116分钟",
    director: "黄立森",
    actors: ["郑淮", "罗砚秋", "白薇"],
    subtitle: "简体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=industrial%20hometown%20drama%20poster%20of%20a%20fading%20steel%20factory%20at%20dusk%2C%20warm%20rust%20and%20deep%20burgundy%20tones%2C%20nostalgic%20grain%2C%20cinematic%20vertical%20layout&width=600&height=900&seq=movie-poster-jky024&orientation=portrait",
    description: "下岗潮里，一个岳姓家庭用二十年时间，学会了怎样体面地告别一座厂。",
    tags: ["年代", "家庭", "东北"],
  },
  {
    id: "jky-025",
    title: "饥渴的岳：暗号",
    year: 2025,
    region: "中国香港",
    genres: ["惊悚", "动作"],
    version: "中文字幕4K",
    rating: 7.6,
    views: 79400,
    duration: "125分钟",
    director: "陈屿舟",
    actors: ["梁烬", "顾也", "崔敏书"],
    subtitle: "简体中文 / 繁体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=spy%20thriller%20poster%20with%20glowing%20red%20Morse%20code%20signals%20over%20a%20black%20cityscape%2C%20deep%20crimson%20dots%2C%20minimal%20tense%20cinematic%20vertical%20composition&width=600&height=900&seq=movie-poster-jky025&orientation=portrait",
    description: "一串只有三个人听得懂的暗号，正在把岳山河一步步引向陷阱。",
    tags: ["谍战", "暗号", "都市"],
  },
  {
    id: "jky-026",
    title: "饥渴的岳：旧钟",
    year: 2023,
    region: "法国",
    genres: ["文艺", "科幻"],
    version: "中文字幕BD",
    rating: 7.7,
    views: 24100,
    duration: "101分钟",
    director: "Léa Aubert",
    actors: ["罗砚秋", "Elena Ward"],
    subtitle: "简体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=surreal%20sci%20fi%20art%20poster%20of%20a%20giant%20old%20clock%20ticking%20in%20an%20empty%20room%2C%20deep%20red%20gears%2C%20muted%20grey%20light%2C%20poetic%20vertical%20cinematic%20layout&width=600&height=900&seq=movie-poster-jky026&orientation=portrait",
    description: "一座能倒转时间的旧钟，让岳家最后的继承者反复回到同一个黄昏。",
    tags: ["科幻", "时间", "文艺"],
  },
  {
    id: "jky-027",
    title: "饥渴的岳：断线风筝",
    year: 2021,
    region: "中国台湾",
    genres: ["剧情", "爱情"],
    version: "中文字幕HD",
    rating: 7.3,
    views: 27300,
    duration: "107分钟",
    director: "黄立森",
    actors: ["白薇", "何仲川"],
    subtitle: "繁体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=tender%20romantic%20drama%20poster%20of%20a%20kite%20string%20slipping%20from%20a%20hand%20against%20a%20dusk%20deep%20crimson%20sky%2C%20soft%20grain%2C%20emotional%20minimal%20vertical%20composition&width=600&height=900&seq=movie-poster-jky027&orientation=portrait",
    description: "她放走了那只风筝，也放走了那个等了她整个青春的人。",
    tags: ["爱情", "青春", "遗憾"],
  },
  {
    id: "jky-028",
    title: "饥渴的岳：归墟",
    year: 2026,
    region: "中国大陆",
    genres: ["科幻", "悬疑"],
    version: "中文字幕4K",
    rating: 8.3,
    views: 41200,
    duration: "142分钟",
    director: "沈砚",
    actors: ["梁烬", "白薇", "林越"],
    subtitle: "简体中文 / 繁体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=epic%20sci%20fi%20poster%20of%20a%20vast%20dark%20whirlpool%20abyss%20with%20a%20deep%20red%20core%2C%20cosmic%20scale%2C%20black%20and%20crimson%20palette%2C%20dramatic%20cinematic%20vertical%20layout&width=600&height=900&seq=movie-poster-jky028&orientation=portrait",
    description: "当所有故事都被吞噬进归墟，岳山河发现，自己不过是这部史诗里被删掉的一行字。",
    tags: ["科幻", "史诗", "终极"],
  },
  {
    id: "jky-029",
    title: "饥渴的岳：拾荒者",
    year: 2024,
    region: "韩国",
    genres: ["剧情", "犯罪"],
    version: "中文字幕DV",
    rating: 7.5,
    views: 30400,
    duration: "109分钟",
    director: "朴振宇",
    actors: ["李度宪", "郑淮"],
    subtitle: "简体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=raw%20gritty%20drama%20poster%20of%20a%20scavenger%20sorting%20salvaged%20metal%20at%20dawn%2C%20rust%20red%20and%20dark%20ochre%20tones%2C%20documentary%20cinematic%20vertical%20layout&width=600&height=900&seq=movie-poster-jky029&orientation=portrait",
    description: "在废品堆里，他捡到了一卷记录着岳家全部罪证的旧磁带。",
    tags: ["底层", "犯罪", "磁带"],
  },
  {
    id: "jky-030",
    title: "饥渴的岳：双城",
    year: 2022,
    region: "中国香港",
    genres: ["剧情", "犯罪"],
    version: "中文字幕BD",
    rating: 7.9,
    views: 61900,
    duration: "127分钟",
    director: "陈屿舟",
    actors: ["梁烬", "苏婉清", "何仲川"],
    subtitle: "简体中文 / 繁体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=split%20city%20poster%20of%20two%20mirrored%20skylines%20divided%20by%20a%20deep%20red%20river%2C%20dark%20charcoal%20and%20crimson%20palette%2C%20architectural%20cinematic%20vertical%20layout&width=600&height=900&seq=movie-poster-jky030&orientation=portrait",
    description: "同一桩命案，在两座城市里有两个版本。岳山河必须找出哪一个才是真的。",
    tags: ["双城", "港片", "命案"],
  },
  {
    id: "jky-031",
    title: "饥渴的岳：终局",
    year: 2026,
    region: "中国香港",
    genres: ["动作", "悬疑"],
    version: "中文字幕4K合集",
    rating: 8.7,
    views: 187300,
    duration: "148分钟",
    director: "陈屿舟",
    actors: ["梁烬", "顾也", "苏婉清", "林越"],
    subtitle: "简体中文 / 繁体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=epic%20finale%20movie%20poster%20of%20a%20lone%20silhouette%20standing%20before%20a%20burning%20deep%20red%20horizon%2C%20dramatic%20scale%2C%20black%20and%20crimson%20palette%2C%20cinematic%20vertical%20layout&width=600&height=900&seq=movie-poster-jky031&orientation=portrait",
    description: "所有线索在此收束。岳山河终于站在了谜底面前——而谜底，是他自己。",
    tags: ["终章", "史诗", "收官"],
  },
  {
    id: "jky-032",
    title: "饥渴的岳：番外·小人物",
    year: 2023,
    region: "中国台湾",
    genres: ["剧情", "文艺"],
    version: "中文字幕合集",
    rating: 7.2,
    views: 21800,
    duration: "96分钟",
    director: "黄立森",
    actors: ["白薇", "郑淮"],
    subtitle: "繁体中文字幕",
    cover: "https://readdy.ai/api/search-image?query=gentle%20ensemble%20drama%20poster%20of%20ordinary%20people%20in%20a%20small%20alley%20at%20dusk%2C%20warm%20dim%20burgundy%20and%20amber%20light%2C%20human%20documentary%20cinematic%20vertical%20layout&width=600&height=900&seq=movie-poster-jky032&orientation=portrait",
    description: "在岳山河的传奇之外，还有一群被他路过的小人物，各自过着值得被讲述的人生。",
    tags: ["番外", "群像", "温情"],
  },
];

export const regions: string[] = ["全部", "中国香港", "中国大陆", "中国台湾", "日本", "韩国", "美国", "英国", "法国"];

export const years: string[] = ["全部", "2026", "2025", "2024", "2023", "2022", "2021", "2020"];

export const versions: string[] = ["全部", "中文字幕BD", "中文字幕4K", "中文字幕DV", "中文字幕HD", "中文字幕合集"];

export const genres: string[] = ["全部", "剧情", "悬疑", "犯罪", "动作", "惊悚", "爱情", "文艺", "科幻", "家庭", "战争", "运动", "历史"];